import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  effect,
  inject,
  input,
  signal,
  untracked,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '@fc-shared/ui/buttons/button.component';
import { isMobileSignal } from '@fc-shared/utils/is-mobile';

const FULLSCREEN_PANEL_CLASS = 'dialog-full-screen';

@Component({
  selector: 'fc-dialog-fullscreen-toggle',
  imports: [ButtonComponent],
  template: `
    <fc-button
      variant="icon"
      class="hidden! md:flex!"
      (click)="toggleFullscreen()"
      [icon]="fullscreen() ? 'icon-minimize' : 'icon-maximize'"
    />
  `,
  host: {
    '[class.hidden]': '!visible()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogFullscreenToggleComponent implements OnDestroy {
  private readonly dialogRef = inject(MatDialogRef);
  private readonly isMobile = isMobileSignal();

  fullscreen = signal(false);
  forceFullscreen = input<boolean | null>(null);
  visible = input(true);

  constructor() {
    effect(() => {
      const forced = this.forceFullscreen();
      if (forced === null) {
        return;
      }

      untracked(() => this.setFullscreen(forced));
    });

    effect(() => {
      if (this.fullscreen() && !this.isMobile()) {
        this.dialogRef.addPanelClass(FULLSCREEN_PANEL_CLASS);
      } else {
        this.dialogRef.removePanelClass(FULLSCREEN_PANEL_CLASS);
      }
    });
  }

  ngOnDestroy(): void {
    this.dialogRef.removePanelClass(FULLSCREEN_PANEL_CLASS);
  }

  toggleFullscreen(): void {
    this.setFullscreen(!this.fullscreen());
  }

  private setFullscreen(fullscreen: boolean): void {
    this.fullscreen.set(fullscreen);
  }
}
